import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/index';
import Layout from './components/layout/Layout';
import { initializeBlogData } from './utils/initBlogData';
import './utils/clearBlogData'; // 导入清除数据工具

function App() {
  useEffect(() => {
    // 初始化博客数据
    initializeBlogData().catch(console.error);
  }, []);

  return (
    <Router>
      <Layout>
        <AppRoutes />
      </Layout>
    </Router>
  );
}

export default App;